export default function ProblematiqueSection() {
  return (
    <section id="problematique" className="grid md:grid-cols-2 min-h-screen">
      {/* Partie gauche - Image avec texte */}
      <div className="relative bg-[#F9F5F2] min-h-[600px] md:min-h-screen flex items-end">
        <img 
          src="https://static.readdy.ai/image/972e8dcf8005bdff37194c729f906789/c58e06f801cab74cbaa6035dd4747efb.jpeg"
          alt="Cavalière montrant de l'inconfort"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        
        <div className="relative z-10 p-12">
          <div className="text-xs font-light text-white/70 mb-4 tracking-wider">/problématique</div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Quand l'endométriose<br />
            empêche les cavalières<br />
            d'exprimer leur potentiel
          </h2>
        </div>
      </div>

      {/* Partie droite - Contenu texte */}
      <div className="bg-white flex items-center justify-center p-12 md:p-16">
        <div className="max-w-lg">
          <h3 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-8 text-center" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Des impacts réels sur votre équitation
          </h3>
          
          <p className="text-base md:text-lg text-[#6B6B6B] leading-relaxed text-center mb-12" style={{ lineHeight: '1.7' }}>
            De nombreuses cavalières atteintes d'endométriose voient leur pratique profondément impactée. Douleurs pelviennes, lombaires, irradiations dans les jambes, inconfort permanent, fatigue chronique… À cheval, ces douleurs ne sont pas anodines.
          </p>

          <div className="space-y-4 mb-12">
            {[
              'Une perte de mobilité du bassin',
              'Des tensions corporelles constantes',
              'Une respiration bloquée',
              'Une diminution de la concentration',
              'Une perte de fluidité dans les aides'
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-arrow-right-line text-[#E8956F] text-lg"></i>
                </div>
                <p className="text-[#3A3A3A] text-base">{item}</p>
              </div>
            ))}
          </div>

          <a 
            href="#solution"
            className="mx-auto block w-fit px-8 py-4 bg-[#3D2817] text-white rounded-full text-sm font-medium hover:bg-[#2C1810] transition-all whitespace-nowrap cursor-pointer"
          >
            Voir la solution <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
